'use strict';

var request = require('./request');

var PATH = 'catalogue';
var ITEM_PATH = 'catalogue-item';
var ITEM_COPY_PATH = 'catalogue-item-copy';

var DatasourceApi = {

  load: function load() {
    return request.get(PATH);
  },

  add: function add(params) {
    return request.post(PATH, params);
  },

  update: function update(id, params) {
    return request.put(PATH + '/' + id, params);
  },

  loadItems: function loadItems(id) {
    return request.get(PATH + '/' + id);
  },

  'delete': function _delete(id) {
    return request['delete'](PATH + '/' + id);
  },

  deleteItems: function deleteItems(datasourceId, itemIds) {
    return request['delete'](PATH + '/' + datasourceId + '/' + itemIds.join(','));
  },

  copyItemsTo: function copyItemsTo(targetDatasourceId, itemIds) {
    return request.post(ITEM_COPY_PATH, {
      targetDatasourceId: targetDatasourceId,
      itemIds: itemIds
    });
  },

  updateItem: function updateItem(itemId, changes, removals) {
    return request.put(ITEM_PATH + '/' + itemId, { changes: changes, removals: removals });
  },

  createItem: function createItem(datasourceId, template) {
    return request.post('' + ITEM_PATH, { datasourceId: datasourceId, template: template });
  }

};

module.exports = DatasourceApi;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/api/datasource.js
 **/